import React from "react";
import "./Calc.css";

class Calc extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rate: "",
      result: 0,
    };
  }

  static getDerivedStateFromProps(props, state) {
    return { rate: props.rate };
  }

  calculate = (event) => {
    event.preventDefault();
    let elements = event.target.elements;
    let countCurrency = elements["count-currency"].value;
    let typeCurrency = elements["type-currency"].value;
    this.setState({ result: countCurrency / this.state.rate[typeCurrency] });
  };

  render() {
    return (
      <div className="calculator">
        <h3> Калькулятор обмена</h3>
        <form onSubmit={this.calculate}>
          <div className="block">
            <div>Я хочу</div>
            <div>
              <input type="number" defaultValue="150" name="count-currency" />
              <select name="type-currency" id="">
                {Object.keys(this.props.rate).map((keyName, i) => (
                  <option key={keyName} value={keyName}>
                    {keyName}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <h4>Результат</h4>
              <ul className="calc-res">
                <li>EUR {this.state.result.toFixed(2)}</li>
              </ul>
            </div>
            <input type="submit" defaultValue="calc" />
          </div>
        </form>
      </div>
    );
  }
}

export default Calc;
